let videoCarousel = new Swiper('.section-video-carousel .swiper', {
  initialSlide: 1,
  slidesPerView: 1.3,
  centeredSlides: true,
  loop: true,
  preventClicks:false,
  spaceBetween: 20,
  grabCursor: true,
  navigation: {
    prevEl: '.video-prev',
    nextEl: '.video-next'
  },
  breakpoints: {
    800: {
      slidesPerView: 5,
      initialSlide: 0,
      centeredSlides: false,
      spaceBetween: 20
    }
  }
})